import destroy from "../../../destroy";
import init from "../../../manual";
import { G_variablesAsync } from "../../../utils/globals/variables";
import WINDOW from "../../../utils/window";

/**
 * Re-initialize the elements that has reference to the global variables `$$`
 * If the element with a `$$` global variable definition is lower in DOM than actual element that references to it,
 * the TorusKit still doesn't know that, because it is not available during the mutation phase.
 */
const processAsyncVariables = () => {
  if (G_variablesAsync.size) {
    const original = [...G_variablesAsync];

    WINDOW.set("async-variables-attempt", 1);

    destroy(G_variablesAsync);
    init(original);
  }
};

export default processAsyncVariables;
